import { DeviceModelId } from "@ledgerhq/devices";
export const supportedDeviceModelIds = [DeviceModelId.stax, DeviceModelId.europa];
export function isCustomLockScreenSupported(deviceModelId) {
    switch (deviceModelId) {
        case DeviceModelId.stax:
        case DeviceModelId.europa:
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=isCustomLockScreenSupported.js.map